import { Box, useMediaQuery } from "@mui/material";
import { DashboardNavbar } from "../components/navbar/dashboard-navbar";
import { DashboardSidebar } from "../components/sidebar/dashboard-sidebar";
import { drawerWidth } from "../utils/constants";
import { useAppSelector } from "../app/hooks";
export const DashboardLayout = (props: any) => {
  const { children } = props;
  const { drawer } = useAppSelector((state) => state.dashboard);

  const lgUp = useMediaQuery((theme: any) => theme.breakpoints.up("lg"), {
    defaultMatches: true,
    noSsr: false,
  });

  return (
    <>
      <Box
        style={{
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          width: "100%",
          paddingTop: 66,
          paddingLeft: !lgUp ? 0 : drawer ? drawerWidth : 66,
        }}
      >
        {children}
      </Box>

      <DashboardNavbar lgUp={lgUp} />
      <DashboardSidebar lgUp={lgUp} />
    </>
  );
};
